import React, { useState } from 'react';
import Sidebar from './sidebar';
import TopBar from './topbar';
import './pageLayout.css';

export default function PageLayout({ children, activePage }) {
  const [page, setPage] = useState(activePage || 'dashboard');

  return (
    <div className="layout">
      <Sidebar activePage={page} onNavigate={setPage} />
      <div className="layout-main">
        <TopBar />
        <main className="layout-content">
          {children}
        </main>
      </div>
    </div>
  );
}